import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./radioButtonForm.scss";

const RadioButtonForm = ({id, name, value, selectedOption, onChange}) => (
	<div className={styles.radioButtonWrapper}>
		<input 
			type="radio" 
			id={id} 
			name={name} 
			value={value} 
			aria-labelledby={`${id}-label`} 
			checked={selectedOption === value} 
			onChange={onChange} 
			required 
			className={cx(styles.radioInput, styles.customRadio, {
                [styles.selected]: selectedOption === value,
            })}
        />
		<label
			htmlFor={id}
			id={`${id}-label`}
			className={styles.label}
            >
			{name}
		</label>
	</div>
)


RadioButtonForm.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    selectedOption: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};


export { RadioButtonForm }
export default RadioButtonForm